import { useContext } from 'react';
import { AppContext } from '~/providers/App';

export const useUser = () => {
  try {
    const app = useContext(AppContext);
    const user = app?.user || null;
    const isUserLoaded = app?.isUserLoaded ?? false;

    return { user, isUserLoaded };
  } catch (error) {
    console.warn('Error accessing user context:', error);
    return { user: null, isUserLoaded: false };
  }
};
